// extracted by mini-css-extract-plugin
export default {"card":"chooseReasonCard_card__VfTlV","cardImage":"chooseReasonCard_cardImage__xs22K","selectedCard":"chooseReasonCard_selectedCard__iwXDM"};